import React, { FunctionComponent } from 'react';
import { DatePicker } from '@material-ui/pickers';
import styles from './DatePicker.module.scss';
import { _t } from 'app/utils/i18n';
import { DateIcon, ResetIcon } from 'app/assets/images/icons';
import { datePickerFormatter } from 'app/utils/datePickerFormatter';
import PopperQuestionMark from 'app/components/PopperQuestionMark';
import { IconButton } from '@material-ui/core';

interface Props {
  value: string;
  icon?: JSX.Element;
  placeholder?: string;
  onChange: (date: any) => void;
  maxDate?: any;
  minDate?: any;
  label?: string;
  name?: string;
  error?: any;
  disabled?: boolean;
  showQuestionMarkDetails?: boolean;
  yearsOnly?: boolean;
  isClearButton?: boolean;
  compId?: string;
}

const MainDatePicker: FunctionComponent<Props> = ({
  value = null,
  onChange,
  icon = <DateIcon />,
  placeholder,
  maxDate,
  minDate,
  label,
  name,
  error,
  disabled,
  showQuestionMarkDetails,
  yearsOnly,
  isClearButton,
  compId,
}) => {
  const initialMaxDate =
    maxDate == undefined
      ? undefined
      : JSON.stringify(maxDate)?.length
      ? maxDate
      : new Date();

  const datePicked = (v: any) => {
    if (name == 'end_date') {
      onChange?.(datePickerFormatter(v).end);
    } else {
      onChange?.(datePickerFormatter(v).start);
    }
  };

  const errorMessage = error ? error[name || '']?.message : '';
  return (
    <div className={styles.DatePicker} data-testid="DatePicker-holder">
      <div
        className={
          errorMessage
            ? styles.DatePicker__Label_Error
            : styles.DatePicker__Label
        }
      >
        <div className="flex-center-between">
          {label && (
            <label
              data-testid="label-holder"
              className={disabled ? 'labelDisabled' : ''}
            >
              {label}
            </label>
          )}
          {showQuestionMarkDetails && <PopperQuestionMark compId={compId} />}
        </div>

        {error && <p data-testid="error-holder">{errorMessage}</p>}
      </div>
      <div
        className={`${
          errorMessage
            ? styles.DatePicker__Input_error
            : styles.DatePicker__Input
        } ${disabled ? styles.DatePicker__Input_disabled : ''}`}
        id="date-picker"
        data-testid="date-picker-input-holder"
      >
        <DatePicker
          views={yearsOnly ? ['year'] : undefined}
          data-testid="date-picker-testid"
          leftArrowIcon={_t('prev')}
          rightArrowIcon={_t('next')}
          variant="inline"
          format={yearsOnly ? 'yyy' : 'dd/MM/yyyy'}
          margin="normal"
          id="date-picker-inline"
          emptyLabel={placeholder}
          value={value?.length === 0 ? null : value}
          inputVariant="outlined"
          onChange={(value) => datePicked(value)}
          autoOk={true}
          maxDate={initialMaxDate}
          minDate={minDate}
          initialFocusedDate={maxDate ? undefined : initialMaxDate}
          orientation="portrait"
          disabled={disabled ? disabled : false}
          InputProps={
            isClearButton
              ? {
                  endAdornment: (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onChange?.('');
                      }}
                      className={styles.resetIcon_wrapper}
                      data-testid="clear-button-holder"
                    >
                      <ResetIcon />
                    </IconButton>
                  ),
                }
              : {}
          }
        />
        <div className={styles.DatePicker__Icon} data-testid="icon-holder">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default MainDatePicker;
